// extracted by mini-css-extract-plugin
export default {"FieldAccordionDraggableWrapper":"FieldAccordionDraggableWrapper---c2vRL","FieldAccordionDraggableWrapper--dragging":"FieldAccordionDraggableWrapper--dragging---i1jg5"};